// removed by extract-text-webpack-plugin
module.exports = {"pageTitle":"_1Kc3VJezs4LxC4cuxEFqYr","publishTitle":"_258y1LyG5MYjppLJkzF3jJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMTitle/OMTitle.scss
// module id = 1683
// module chunks = 0